import React, { useEffect, useMemo, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import apiClient from '../api/config';
import { useAuth } from '../contexts/AuthContext';
import { useActiveFeatureFlags } from '../hooks/useActiveFeatureFlags';

const DataValidationFrameHost: React.FC = () => {
    const location = useLocation();
    const { user } = useAuth();
    const { flags, maintenance, loading, lastLoadedAt, refresh } = useActiveFeatureFlags();
    const onDataValidationRoute = location.pathname === '/data-validation';
    const isSuperAdmin = Boolean(user && /superadmin/i.test(user.role));
    const wasOnDataValidationRouteRef = useRef(false);
    const routeEnteredAtRef = useRef(0);

    if (onDataValidationRoute && !wasOnDataValidationRouteRef.current) {
        routeEnteredAtRef.current = Date.now();
    }
    wasOnDataValidationRouteRef.current = onDataValidationRoute;

    const needsFreshRouteMaintenanceCheck = Boolean(
        onDataValidationRoute
        && !isSuperAdmin
        && lastLoadedAt < routeEnteredAtRef.current,
    );
    const dataValidationMaintenanceActive = Boolean(
        !isSuperAdmin
        && flags.data_validation_agent
        && maintenance.data_validation?.maintenance_enabled,
    );

    useEffect(() => {
        if (needsFreshRouteMaintenanceCheck) {
            refresh();
        }
    }, [needsFreshRouteMaintenanceCheck, refresh]);

    const iframeSrc = useMemo(() => {
        const configuredBase = String(apiClient.defaults.baseURL || '').trim();
        const base = configuredBase === '/' ? '' : configuredBase.replace(/\/$/, '');
        const params = new URLSearchParams({
            apiBase: base,
            v: '20250603-silent-compare',
        });
        return `/data-validation-app/index.html?${params.toString()}`;
    }, []);

    if (
        loading
        || needsFreshRouteMaintenanceCheck
        || !flags.data_validation_agent
        || !onDataValidationRoute
        || dataValidationMaintenanceActive
    ) {
        return null;
    }

    return (
        <div
            style={{
                position: 'absolute',
                inset: 0,
                zIndex: 5,
                background: '#f8fafc',
            }}
        >
            <iframe
                title="Data Validation"
                src={iframeSrc}
                style={{
                    width: '100%',
                    height: '100%',
                    minHeight: 'calc(100vh - 140px)',
                    border: 'none',
                    display: 'block',
                }}
            />
        </div>
    );
};

export default DataValidationFrameHost;
